import React, { Component } from "react";
import { Modal, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import { updateResultLink, createResultLink } from "../../../services/clinicPortalServices/orderEditService";
import moment from "moment";
import { getUserFullName, getUserID } from "../../../services/common/util";
import { Switch } from "@mui/material";
import Swal from "sweetalert2";
import toastr from "toastr";
import { ModalStyled } from "../../../theme/customizedStyleComponents";

export default class ResultLink extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showResultLink: false,
            resultLink: "",
            isResultViewEnabled: false,
            resultId: "",
            status: ""
        };
    }

    renderTooltipLink = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Result Link
        </Tooltip>
    );

    renderTooltipCopyLink = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Copy Link
        </Tooltip>
    );

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleLink = () => {
        Swal.fire({
            title: "Did you get the permission?",
            text: "Did you get the customers or physicians permission via email or phone prior to providing this one time link?",
            icon: "info",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            customClass: {
                container:
                    window.localStorage.getItem("appTheme") === "Dark" &&
                    /clinic|lims/.test(window.location.pathname.split("/")[1]) &&
                    "dark-swal",
                cancelButton: "order-1",
                confirmButton: "order-2"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.createLink();
            }
        });
    };

    createLink = () => {
        const { orderId, patientId } = this.props;
        const params = {
            order_id: orderId,
            patient_id: patientId,
            is_viewed: false,
            is_pdf_viewed: false,
            is_downloaded: false,
            $push: {
                managed: {
                    manager_id: getUserID(),
                    manager_name: getUserFullName(),
                    status: "Created",
                    managed_date: moment().format("YYYYMMDDHHmmss")
                }
            }
        };

        createResultLink(params).then((response) => {
            const data = response.data;
            if (data.success) {
                this.setState({
                    showResultLink: true,
                    resultLink: data.link,
                    resultId: data.data._id,
                    status: data.status,
                    isResultViewEnabled: !data.data.is_viewed
                });
            }
        });
    };

    handleSwitchChange = (e) => {
        let params = {
            _id: this.state.resultId,
            is_viewed: !e.target.checked,
            is_downloaded: !e.target.checked,
            is_pdf_viewed: !e.target.checked,
            $push: {
                managed: {
                    manager_id: getUserID(),
                    manager_name: getUserFullName(),
                    status: e.target.checked ? "Enabled" : "Disabled",
                    managed_date: moment().format("YYYYMMDDHHmmss")
                }
            }
        };
        updateResultLink(params).then((response) => {
            const data = response.data;
            if (data.success) {
                const message = e.target.checked ? "The link is enabled." : "The link is disabled";
                toastr.success(message);
            }
        });
        this.setState({ [e.target.name]: e.target.checked });
    };

    handleCloseResultLink = () => {
        this.setState({
            showResultLink: false,
            resultLink: "",
            isResultViewEnabled: false
        });
    };

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipLink}>
                    <button className="edit-order-btn" onClick={() => this.handleLink()}>
                        <i className="fa fa-link" aria-hidden="true"></i>
                    </button>
                </OverlayTrigger>
                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.showResultLink}
                    onHide={this.handleCloseResultLink}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Result Link</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row form-row align-items-center">
                            <div className="col-11 col-md-11">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="resultLink"
                                    value={this.state.resultLink}
                                    ref={(textarea) => (this.textArea = textarea)}
                                />
                            </div>
                            <div className="col-1 col-md-1">
                                <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 50, hide: 100 }}
                                    overlay={this.renderTooltipCopyLink}
                                >
                                    <button onClick={this.copyCodeToClipboard} className="edit-order-btn">
                                        <i className="fa fa-clone"></i>
                                    </button>
                                </OverlayTrigger>
                            </div>
                            <div className="col-12 mt-4">
                                <Switch
                                    onChange={this.handleSwitchChange}
                                    checked={this.state.isResultViewEnabled}
                                    name="isResultViewEnabled"
                                />
                                <label>{this.state.isResultViewEnabled ? "Enabled" : "Disabled"}</label>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseResultLink}>
                            Close
                        </Button>
                    </Modal.Footer>
                </ModalStyled>
            </div>
        );
    }
}
